import React, {
  Dispatch,
  FunctionComponent,
  SetStateAction,
  useState,
} from 'react';
import { Box, Button, TextField, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles<Theme>((theme) => ({
  email: {
    margin: theme.spacing(2, 'auto'),
    maxWidth: theme.spacing(40),
  },
  textField: {
    width: '100%',
  },
  input: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  primaryButton: {
    width: '100%',
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
  },
}));

interface GetEmailProps {
  onValidatedSumbit: (email: string) => void;
  setIsSubmited: Dispatch<SetStateAction<boolean>>;
  isSubmited: boolean;
  buttonLabel: string;
}

export const GetEmail: FunctionComponent<GetEmailProps> = (props) => {
  const classes = useStyles();
  const [error, setError] = useState<boolean>(false);
  const [helperText, setHelperText] = useState<string>();
  const [email, setEmail] = useState<string>('');

  const EMAIL_REGEX =
    /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;

  const onChange = (email) => {
    setEmail(email);
    if (EMAIL_REGEX.test(email)) {
      setError(false);
      setHelperText('');
    }
  };

  const onClick = () => {
    if (EMAIL_REGEX.test(email) && !props.isSubmited) {
      setError(false);
      setHelperText('');
      props.setIsSubmited(true);
      props.onValidatedSumbit(email);
    } else {
      setError(true);
      setHelperText('Wprowadź poprawny email.');
    }
  };

  return (
    <Box m={2} className={classes.email}>
      <TextField
        error={error}
        helperText={helperText}
        className={classes.textField}
        type="email"
        autoComplete="email"
        label="Email"
        placeholder="Email"
        InputProps={{ classes: { root: classes.input } }}
        value={email}
        onChange={(event) => onChange(event.target.value)}
      />
      <Button
        onClick={onClick}
        className={classes.primaryButton}
        variant="contained"
        size="large"
      >
        {props.buttonLabel}
      </Button>
    </Box>
  );
};

export default GetEmail;
